export class MachineTag {
  tag: string;
  category: string;
  applyToMachinesOfSameTag: boolean;
  isNewlyAddedTag: boolean;
  syncTrafficLightSettings: boolean;

  constructor(category: string, tag: string) {
    this.tag = tag;
    this.category = category;
    this.applyToMachinesOfSameTag = false;
    this.isNewlyAddedTag = true;
    this.syncTrafficLightSettings = false;
  }
}